import { loadStripe } from '@stripe/stripe-js';
import api from './api';

let stripePromise = null;

export async function getStripe() {
  if (!stripePromise) {
    const { data } = await api.get('/stripe/config');
    stripePromise = loadStripe(data.publishableKey);
  }
  return stripePromise;
}

export const stripeService = {
  async createCheckoutSession(priceId, customerId) {
    try {
      const response = await api.post('/stripe/create-checkout-session', {
        priceId,
        customerId
      });
      return response.data;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  },

  async getSessionStatus(sessionId) {
    try {
      const response = await api.get('/stripe/session-status', {
        params: { sessionId }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching session status:', error);
      throw error;
    }
  },

  async createCustomerPortalSession(customerId) {
    try {
      const response = await api.post('/stripe/create-customer-portal-session', {
        customerId
      });
      return response.data;
    } catch (error) {
      console.error('Error creating customer portal session:', error);
      throw error;
    }
  },

  async getPricing() {
    try {
      const response = await api.get('/stripe/pricing');
      return response.data;
    } catch (error) {
      console.error('Error fetching pricing:', error);
      throw error;
    }
  },

  async getSubscriptionDetails() {
    try {
      const response = await api.get('/stripe/subscription');
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription details:', error);
      throw error;
    }
  },

  async getBillingInfo() {
    try {
      const response = await api.get('/stripe/billing');
      return response.data;
    } catch (error) {
      console.error('Error fetching billing info:', error);
      throw error;
    }
  },

  async getInvoices() {
    try {
      const response = await api.get('/stripe/invoices');
      return response.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },

  async cancelSubscription() {
    try {
      const response = await api.post('/stripe/cancel-subscription');
      return response.data;
    } catch (error) {
      console.error('Error cancelling subscription:', error);
      throw error;
    }
  },

  async resumeSubscription() {
    try {
      const response = await api.post('/stripe/resume-subscription');
      return response.data;
    } catch (error) {
      console.error('Error resuming subscription:', error);
      throw error;
    }
  },

  async createSetupIntent() {
    try {
      const response = await api.post('/stripe/setup-intent');
      return response.data; // { clientSecret }
    } catch (error) {
      console.error('Error creating setup intent:', error);
      throw error;
    }
  },

  async setDefaultPaymentMethod(setupIntentId) {
    try {
      const response = await api.post('/stripe/payment-method/default', { setupIntentId });
      return response.data;
    } catch (error) {
      console.error('Error setting default payment method:', error);
      throw error;
    }
  }
};

export default stripeService;
